(function () {
  'use strict';

  angular
    .module('flyingHoursAllowance')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('flyingHoursAllowance', {
        url: '/flying-hours-allowance',
        views : {
          'flyingHoursAllowanceView' : {
            templateUrl: 'flying-hours-allowance/views/flying-hours-allowance.tpl.html',
            controller: 'FlyingHoursAllowanceCtrl',
            controllerAs: 'flyingHoursAllowance'
          }
        }
      });
  }
}());
